// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qe-2";
export var chatLink = "_qe-0";
export var chatText = "_qe-1";